.app-body{height:100vh;width:100%}
/*# sourceMappingURL=app.component-ZQN6Y6LT.css.map */
